module.exports = __webpack_public_path__ + "img/font-style.05017583.svg";